import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ListGroupItem } from 'reactstrap';
import moment from 'moment';
import { uiDateFormat } from '../../../constants/date';
import { appPath } from '../../../constants';

export default class InterviewListItem extends Component {
  static propTypes = {
    interview: PropTypes.object.isRequired,
    pathname: PropTypes.string.isRequired
  };

  render () {
    const { pathname, interview } = this.props;
    const { passed, interview_comment: comment, interview_date_time, user_id, first_name, last_name } = interview;
    const isCompleted = moment().isAfter(interview_date_time);
    return (
      <ListGroupItem>
        <div className='d-flex justify-content-between align-items-center flex-wrap'>
          <h4>
            { user_id ? (
              <NavLink
                to={{
                  pathname: `/${appPath}/workers/${user_id}`,
                  state: {
                    backPath: pathname
                  }
                }}
              >{`${first_name} ${last_name}`}</NavLink>
            ) : <span className='text-muted'>John Doe</span>}
          </h4>
          { passed === null ? (
            <div className={`p-1 button button-badge button-static ${isCompleted ? 'button-cancel' : 'button-edit'}`}>
              { isCompleted ? 'No Decision' : 'Scheduled' }
            </div>
          ) : (
            <div className={`p-1 button button-badge button-static ${passed ? 'button-primary' : 'button-delete'}`}>
              { passed ? 'Passed' : 'Declined' }
            </div>
          )}
        </div>
        <div>{ moment.utc(interview_date_time).format(uiDateFormat) }</div>
        { comment && <p>{ comment }</p> }
      </ListGroupItem>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/interviewsList/InterviewListItem.js